import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useAssociatedObjectsCardContentContext } from '../../../context/AssociatedObjectsCardContext';
import { useContactInfluencedCampaigns } from './hooks/useContactInfluencedCampaigns';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const useCampaignCardFooterAction = args => {
  const {
    fromObjectId,
    fromObjectTypeId
  } = args;
  const {
    primaryDisplayLabel
  } = useAssociatedObjectsCardContentContext();
  const sendOpenInfluencedCampaignsPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_INFLUENCED_CAMPAIGNS_PANEL);
  const {
    campaigns: campaignIds,
    loading: campaignsLoading
  } = useContactInfluencedCampaigns(fromObjectId);
  const handleOpenInfluencedCampaigns = useCallback(() => {
    sendOpenInfluencedCampaignsPanel({
      contactId: fromObjectId,
      contactName: primaryDisplayLabel || undefined
    });
  }, [fromObjectId, primaryDisplayLabel, sendOpenInfluencedCampaignsPanel]);
  if (campaignsLoading || !campaignIds.length || fromObjectTypeId !== CONTACT_TYPE_ID) {
    return {
      primaryActionConfig: null
    };
  }
  return {
    primaryActionConfig: {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.ContactInfluencedCampaignsObjectsCardContent.title",
        options: {
          count: campaignIds.length
        }
      }),
      onClick: handleOpenInfluencedCampaigns
    }
  };
};
export default useCampaignCardFooterAction;